@for(mealType of mealTypes; track $index){
<form class="container mt-4 p-4 meal">
  <div class="card text-center">
    <div class="card-header">
      <h5 id="headingMealType" class="card-title">{{mealType}}</h5>
    </div>
    <div class="card-body">

      <app-meal-card-tabs (mealViewModelsChange)="onMealChange($event)" [mealViewModels]="mealViewModels" [mealType]="mealType"></app-meal-card-tabs>

      <p class="card-text">This is your {{mealType}} diary. After entering your food and quantities, you will be able to see your total daily caloric and
        macronutrient intake.</p>
    </div>
  </div>
</form>
}
